import * as actions from './actionTypes';

export function getPolicyDetails(dateOfLoss, resolve = () => {}) {
  return {
    type: actions.GET_POLICY_DETAILS,
    payload: { dateOfLoss, onComplete: resolve },
  };
}

export function setPolicyDetails(policyDetails) {
  return {
    type: actions.SET_POLICY_DETAILS,
    payload: { policyDetails },
  };
}

export function setPolicyDetailsError(error) {
  return {
    type: actions.SET_POLICY_DETAILS_ERROR,
    payload: { error },
  };
}

export function clearPolicyDetails() {
  return { type: actions.CLEAR_POLICY_DETAILS };
}

export function clearPolicyDetailsError() {
  return { type: actions.CLEAR_POLICY_DETAILS_ERROR };
}
